const TEMPLATE = `
<section class="precision-in-diagnostics fade-up">
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-6">
                <p class="section-label" data-animate-child>Про нас у цифрах</p>
            </div>
            <div class="col-md-6">
                <h3 data-animate-child data-delay="200">Довіра, підтверджена результатами</h3>
                <p data-animate-child data-delay="400">
                    Ми розробили процеси, що гарантують швидкість, точність і надійність результату кожного
                    дослідження. Наші показники відображають масштаб роботи лабораторії, довіру лікарів та стабільну
                    якість діагностики.
                </p>
            </div>
        </div>
        <div class="diagnostics-circles-section" data-animate-child data-delay="600">
            <div class="diagnostic-circle">
                <div class="circle-content">
                    <h2 class="circle-value">5 днів</h2>
                    <p class="circle-description">Стандартний термін виконання патогістологічного дослідження у BML</p>
                </div>
            </div>
            <div class="diagnostic-circle">
                <div class="circle-content">
                    <h2 class="circle-value">36 годин</h2>
                    <p class="circle-description">Швидкість термінового патогістологічного дослідження для критичних випадків</p>
                </div>
            </div>
            <div class="diagnostic-circle">
                <div class="circle-content">
                    <h2 class="circle-value">100%</h2>
                    <p class="circle-description">Вірних діагнозів за результатами міжнародної системи зовнішньої оцінки якості (EQA)</p>
                </div>
            </div>
            <div class="diagnostic-circle">
                <div class="circle-content">
                    <h2 class="circle-value">до 15 хв</h2>
                    <p class="circle-description">Час реакції нашої команди на будь-який робочий запит від партнерів</p>
                </div>
            </div>
        </div>
        <div class="video-section" data-animate-child data-delay="1000">
            <div class="video-wrapper" data-content="youtube-video" data-page="about-work" data-attribute="video"
                 data-original-attribute="video">
                <img src="/images/video/image.png" alt="Мікроскопія в BML" class="video-thumbnail">
                <button class="play-button"></button>
            </div>
        </div>
    </div>
</section>
`;

class BmlAboutWorkStats extends HTMLElement {
    connectedCallback() { if (!this.innerHTML.trim()) this.innerHTML = TEMPLATE; }
}
customElements.define('bml-about-work-stats', BmlAboutWorkStats);
